module.exports = __webpack_public_path__ + "static/img/bdxy.bf5d16e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bdxy.png
// module id = ovYA
// module chunks = 3